// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CheckboxTsx from "./Checkbox.tsx";
import * as JsxRuntime from "react/jsx-runtime";

let make = CheckboxTsx.Checkbox;

function Checkbox(props) {
  let value = props.value;
  let match;
  if (value !== undefined) {
    switch (value) {
      case "Checked" :
        match = [
          true,
          undefined
        ];
        break;
      case "Unchecked" :
        match = [
          false,
          undefined
        ];
        break;
      case "Indeterminate" :
        match = [
          undefined,
          true
        ];
        break;
    }
  } else {
    match = [
      undefined,
      undefined
    ];
  }
  return JsxRuntime.jsx(make, {
    checked: match[0],
    indeterminate: match[1],
    disabled: props.disabled,
    accent: props.accent,
    size: props.size,
    ariaLabel: props.ariaLabel,
    onChange: props.onChange,
    hovered: props.hovered,
    isolatePress: props.isolatePress,
    ariaProps: props.ariaProps
  });
}

let make$1 = Checkbox;

export {
  make$1 as make,
}
/* make Not a pure module */
